/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '@/app/store/actions/';
import * as UserActions from '@/app/auth/store/actions/user.actions';
import axios from '@shared/axios-shared';
import JwtService from '@/app/services/jwtService';
import * as PusherPushNotifications from '@pusher/push-notifications-web';
import SchoolListDialog from './SchoolListDialog';
import secureLocalStorage from 'react-secure-storage';
import { useNavigate } from 'react-router-dom';

/* The `ViewAs` function is a React component that renders a UI for switching between different user
roles in an application. This is rendered in the navigation bar of super admin and super school admin (super admin acting as school admin) */
const ViewAs = () => {
	const dispatch = useDispatch();
	let goBackInProgress = false;
	const user = useSelector(({ auth }) => auth.user);
	const navigate = useNavigate();
	const handleSwitchAdmin = () => {
		dispatch(
			Actions.openDialog({
				children: <SchoolListDialog />,
			}),
		);
	};

	const handleBackToSuperAdmin = async () => {
		if (goBackInProgress) {
			return;
		}
		goBackInProgress = true;

		try {
			const serviceWorkerRegistration = await window.navigator.serviceWorker.ready;
			const beamsClient = new PusherPushNotifications.Client({
				instanceId: import.meta.env.VITE_BEAMS_INSTANCE_ID,
				serviceWorkerRegistration,
			});
			await beamsClient.clearAllState();
			console.log('Cleared all beams state');
		} catch (error) {
			console.log('Error clearing beams state');
			console.error(error);
		}

		let superadmin_token = secureLocalStorage.getItem('superadmin_token');
		let data = JSON.parse(secureLocalStorage.getItem('superadmin_data') || '{}');
		const tempUser = JSON.parse(secureLocalStorage.getItem('user'));
		tempUser.role = [data?.role ?? 'super_admin'];
		if (data?.company_id && tempUser.role[0] === 'product_owner') {
			tempUser.data.selected_school = data.school_id;
			tempUser.data.company_id = data.company_id;
			tempUser.data.selected_company = data.company_id;
		} else {
			delete tempUser.data.selected_school;
			delete tempUser.data.selected_company;
		}
		JwtService.setSession(superadmin_token, tempUser);
		secureLocalStorage.removeItem('superadmin_token');
		secureLocalStorage.removeItem('superadmin_data');
		JwtService.setSchool(tempUser.data.selected_company ?? null);
		axios.get('/api/v2/profile').then((res) => {
			tempUser.data.displayName = `${res.data.first_name} ${res.data.last_name}`;
			secureLocalStorage.setItem('user', JSON.stringify(tempUser));
			dispatch(UserActions.setUserData(tempUser));
			navigate('/company');
		});
	};

	const handleBackToProductOwner = async () => {
		await JwtService.logout(false);
		window.location = `${import.meta.env.VITE_PRODUCTOWNER_APP_URL}/productOwner`;
	};

	return (
		<div className="flex flex-col px-24 gap-20 mt-16">
			{['super_admin', 'company_owner', 'super_school_admin', 'product_owner'].includes(user.role[0]) ? (
				<div className="text-white">
					<p className="text-white mb-10">View As:</p>
					<button
						className="text-white w-full text-center border-white rounded-full py-6 px-2 border flex items-center justify-center hover:shadow-md"
						onClick={handleSwitchAdmin}
						type="button"
					>
						Select School <i className="fas fa-angle-down ml-8" />
					</button>
				</div>
			) : (
				''
			)}
			{user.role[0] === 'super_school_admin' ? (
				<button
					className="text-white text-center border-white rounded-full py-6 hover:shadow-md border flex items-center justify-center"
					onClick={handleBackToSuperAdmin}
					type="button"
				>
					Back to Company
				</button>
			) : null}

			{user.role[0] === 'product_owner' && user.data.selected_company ? (
				<button
					className="text-white text-center border-white rounded-full py-6 hover:shadow-md border flex items-center justify-center"
					onClick={handleBackToProductOwner}
					type="button"
				>
					Back to Product Owner
				</button>
			) : null}
		</div>
	);
};

export default ViewAs;
